import React, { Component } from "react";
import { Row, Card, Label, Button, FormGroup, Input } from "reactstrap";

import { connect } from "react-redux";
import { registerUser } from "../../redux/actions";

// import IntlMessages from "../../helpers/IntlMessages";
import { Colxx } from "../../components/common/CustomBootstrap";
import axios from "../../containers/api";

import { toEnglishNumbers, showCatchError } from "../../helpers/Utils";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { Link } from "react-router-dom";

class RegisterProductOwner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      SendActiveCode: true,
      CheckActiveCode: false,
      IsActive: false,
      Mobile:
        this.props.location.state !== undefined &&
        this.props.location.state !== null
          ? this.props.location.state[0].mobile !== null &&
            this.props.location.state[0].mobile !== undefined
            ? this.props.location.state[0].mobile
            : null
          : null,
      ActiveCode: "",
      Register: false,
      Firstname: "",
      Lastname: "",
      MeliCode: "",
      Password: "",
      newMemberUsername: "",
      newMemberPassword: "",
      showNewMember: false,
      errors: [],
    };
    // console.log("test")
  }
  onUserRegister() {
    if (this.state.email !== "" && this.state.password !== "") {
      this.props.history.push("/");
    }
  }
  componentWillMount() {}

  validateInputData = () => {
    let error = [];
    if (this.state.Firstname.length === 0) {
      error.push("وارد كردن نام  الزامی میباشد");
    }
    if (this.state.Lastname.length === 0) {
      error.push("وارد كردن نام خانوادگي الزامی میباشد");
    }
    if (this.state.MeliCode.length < 10) {
      error.push("کد ملی نباید کمتر از ۱۰ حرف باشد.");
    }
    if (this.state.Mobile.length === 0) {
      error.push("وارد كردن تلفن يا موبايل الزامی میباشد.");
    }
    if (this.state.Lastname.length === 0) {
      error.push("وارد كردن کلمه عبور الزامی میباشد");
    }
    this.setState({ errors: error });
    if (error.length === 0) {
      this.AddProductOwner();
    } else {
      this.props.showAlert(error, "error");
    }
  };
  AddProductOwner = () => {
    let addModel = {
      Firstname: toEnglishNumbers(this.state.Firstname),
      Lastname: toEnglishNumbers(this.state.Lastname),
      MeliCode: toEnglishNumbers(this.state.MeliCode),
      Mobile: toEnglishNumbers(this.state.Mobile),
      Password: toEnglishNumbers(this.state.Password),
    };
    console.log("AddModel : " + addModel);
    axios
      .post("/api/v1/product-owners/Add", addModel)
      .then((res) => {
        if (res.status === 200 && res.data.data.code !== -1) {
          this.setState({
            newMemberUsername: res.data.data.result.userName,
            newMemberPassword: res.data.data.result.password,
            Register: false,
          });
          this.props.showAlert(res.data.message, "success");
        } else {
          this.props.showAlert(res.data.data.message, "error");
        }
      })
      .catch((error) => {
        this.props.showAlert(showCatchError(error), "error");
        console.log(error.response);
      });
  };

  render() {
    return (
      <Row className="justify-content-center align-items-center d-flex mt-5">
        <Colxx xxs="12" md="8">
          <Card className="auth-card">
            <div className="form-side justify-content-center align-items-center d-flex flex-column">
              <div className="logo-single mb-2" />
              <div className="flex-column w-100 justify-content-center">
                <FormGroup className="w-md-50 w-100 mx-1">
                  <Label>موبایل</Label>
                  <Input
                    value={this.state.Mobile}
                    maxLength={11}
                    disabled={true}
                    onChange={(e) => this.setState({ Mobile: e.target.value })}
                  />
                </FormGroup>

                <FormGroup className="w-md-50 w-100 mx-1">
                  <Label>نام صاحب کالا</Label>
                  <Input
                    value={this.state.Firstname}
                    maxLength={300}
                    onChange={(e) =>
                      this.setState({ Firstname: e.target.value })
                    }
                  />
                </FormGroup>
              </div>
              <div className="flex-column w-100 justify-content-center">
                <FormGroup className="w-md-50 w-100 mx-1">
                  <Label>نام خانوادگی</Label>
                  <Input
                    value={this.state.Lastname}
                    maxLength={300}
                    onChange={(e) =>
                      this.setState({ Lastname: e.target.value })
                    }
                  />
                </FormGroup>
                <FormGroup className="w-md-50 w-100 mx-1">
                  <Label>کد ملی</Label>
                  <Input
                    value={this.state.MeliCode}
                    maxLength={11}
                    onChange={(e) =>
                      this.setState({ MeliCode: e.target.value })
                    }
                  />
                </FormGroup>
                <FormGroup className="w-md-50 w-100 mx-1">
                  <Label>کلمه عبور</Label>
                  <Input
                    value={this.state.Password}
                    maxLength={300}
                    onChange={(e) =>
                      this.setState({ Password: e.target.value })
                    }
                  />
                </FormGroup>
              </div>

              <div className="flex-column w-100 justify-content-center">
                <Button
                  color="primary"
                  className="btn-lg mx-2"
                  onClick={() => this.validateInputData()}
                >
                  ثبت نام
                </Button>

                <Link to={"/"} type="button">
                  <Button outline color="warning" className="mx-3 my-md-0 my-1">
                    بازگشت
                  </Button>
                </Link>
              </div>

              {this.state.showNewMember === true && (
                <div className="d-flex flex-md-row flex-column w-100 justify-content-center">
                  <FormGroup className="w-md-60 w-100 mx-1">
                    <Label> نام کاربری</Label>
                    <Input
                      value={this.state.newMemberUsername}
                      disabled
                      onChange={(e) =>
                        this.setState({ newMemberUsername: e.target.value })
                      }
                    />
                  </FormGroup>
                  <FormGroup className="w-md-60 w-100 mx-1">
                    <Label> کلمه عبور</Label>
                    <Input
                      value={this.state.newMemberPassword}
                      disabled
                      onChange={(e) =>
                        this.setState({ newMemberPassword: e.target.value })
                      }
                    />
                  </FormGroup>
                </div>
              )}
            </div>
          </Card>
        </Colxx>
      </Row>
    );
  }
}
const mapStateToProps = ({ authUser }) => {
  const { user, loading } = authUser;
  return { user, loading };
};

export default connect(mapStateToProps, {
  registerUser,
})(RegisterProductOwner);
